import { ref, readonly, onMounted, onUnmounted } from 'vue'

const isOpen = ref(false)

export const useMobileMenu = () => {
  const open = () => {
    isOpen.value = true
    if (import.meta.client) {
      document.body.style.overflow = 'hidden'
    }
  }

  const close = () => {
    isOpen.value = false
    if (import.meta.client) {
      document.body.style.overflow = ''
    }
  }

  const toggle = () => {
    if (isOpen.value) {
      close()
    } else {
      open()
    }
  }

  const handleEscape = (event) => {
    if (event.key === 'Escape' && isOpen.value) {
      close()
    }
  }

  onMounted(() => {
    if (import.meta.client) {
      document.addEventListener('keydown', handleEscape)
    }
  })

  onUnmounted(() => {
    if (import.meta.client) {
      document.removeEventListener('keydown', handleEscape)
    }
  })

  return {
    isOpen: readonly(isOpen),
    open,
    close,
    toggle
  }
}
